<div class="team-management-container">
  <div class="cards-grid">
    <div class="box talent-card" *ngIf="false" role="region" aria-labelledby="talentCardTitle">
      <div class="card-header">
        <i class="icon license" aria-hidden="true" [style.color]="teamCards.iconColor"></i>
        <h3 id="talentCardTitle" class="card-title">Talent Details</h3>
      </div>
      <div class="card-body">
        <p class="coming-soon" aria-live="polite">
          Talent Details &amp; more<br>
          are coming Soon
        </p>
      </div>
    </div>
    <div class="box rr-card" *ngIf="false" role="region" aria-labelledby="rrCardTitle">
      <div class="card-header">
        <emerald-icon [icon]="'emoji_events'" [type]="'outlined'" [variant]="'icon'" />
        <h3 id="rrCardTitle" class="card-title">My R&amp;R Nominations Q4</h3>
      </div>
      <div class="card-body">
        <p class="coming-soon" aria-live="polite">
          <span>R&amp;R Nominations</span><br>
          are coming Soon
        </p>
      </div>
    </div>

    <app-team-timesheet-metrics class="timesheet-metrics-slot"></app-team-timesheet-metrics>

    <app-team-performance-summary class="perf-summary-slot"></app-team-performance-summary>

    <div class="rto-card">
      <div class="header">
        <div class="title-row">
          <i class="icon rto-icon" aria-hidden="true"></i>
          <h3 class="title">
            <button type="button" class="title-button" (click)="onOpenNewClick()">
              {{ RtoCard.rtoTitle }}
            </button>
          </h3>
          <emerald-icon
            icon="open_in_new"
            color="#6b7280"
            role="button"
            tabindex="0"
            (click)="onOpenNewClick()"
            (keydown.enter)="onOpenNewClick()"
            (keydown.space)="onOpenNewClick()"
          ></emerald-icon>
        </div>
      </div>
      <div class="chart-wrapper">
        <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
          [type]="chartType">
        </canvas>
      </div>
    </div>
  </div>
</div>